import styled from 'styled-components';

const OverviewRootElement = styled.div`
    padding-top: 48px;
    padding-bottom: 48px;
    @media (max-width: 991px) {
        padding-top: 36px;
        padding-bottom: 36px;
    }
    .overview-section {
        display: flex;
        gap: 24px;
        justify-content: space-between;
        @media (max-width: 991px) {
            flex-direction: column;
        }
        .left-section {
            width: 55%;
            @media (max-width: 991px) {
                width: 100%;
            }
            .overview-logo {
                display: flex;
                width: 172px;
                height: 172px;
                position: relative;
                justify-content: center;
                align-items: center;
                img{
                    object-fit: contain;
                }
            }
            .shimmer-card {
                position: absolute;
            }
            .overview-links {
                border-top: #e5e5e5 solid 1px;
                padding-top: 24px;
                margin-top: 24px;
                display: flex;
                flex-direction: column;
                a {
                    margin: 8px 0;
                    display: flex;
                    align-items: center;
                    word-break: break-all;
                }
                svg {
                    margin-right: 12px;
                }
            }
        }
        .right-section {
            width: 45%;
            p{
             word-break: break-word;
            }
            ul{
                margin-left: 20px;
            }
            @media (max-width: 991px) {
                width: 100%;
            }
        }
    }
`;
export default OverviewRootElement;
